function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
/* Styles */
import "../style/pages/about-us.css";
//@ts-ignore
import PublicUserMenu from "./vue/PublicUserMenu.vue";
import { mapState, mapActions, createPinia } from "pinia";
//@ts-ignore
import { useAppBanner } from "@wkComposables/useAppBanner";
//@ts-ignore
import CommonModals from "./vue/CommonComponents/CommonModals";
//@ts-ignore
import { useFirebaseMessaging } from "@wkComposables/useFirebaseMessaging";
//@ts-ignore
import { BREAKPOINT } from "@customTypes/BreakpointEnum";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import IntersectionObserverVue from "@vueEntry/IntersectionObserver/IntersectionObserverVue.vue";
//@ts-ignore
import IntersectionObservableVue from "@vueEntry/IntersectionObserver/IntersectionObservableVue.vue";
import { createApp, defineAsyncComponent } from "vue";
import { useLoggedUserStore, usePublicUserMenuStore, useModalStore, useBaseStore
//@ts-ignore
} from "@store/index";
//@ts-ignore
import LanguageIcons from "@vueEntry/CommonComponents/LanguageIcons";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
//@ts-ignore
import { useTrustpilotWidget } from "@wkComposables/useTrustpilotWidget";
//@ts-ignore
import { useCommonVars } from "@wkComposables/useCommonVars";
var aboutUsApp = createApp({
  name: "AboutUs",
  components: Object.assign(Object.assign(Object.assign({
    PublicUserMenu: PublicUserMenu,
    IntersectionObserverVue: IntersectionObserverVue,
    IntersectionObservableVue: IntersectionObservableVue,
    //@ts-ignore
    SwiperCarousel: defineAsyncComponent(function () {
      return import("@vueEntry/SwiperCarousel.vue");
    }),
    BaseButton: BaseButton
  }, CommonModals), {
    //@ts-ignore
    "async-dropdown": defineAsyncComponent(function () {
      return import("@vueEntry/UIKitComponents/BaseDropDown.vue");
    })
  }), LanguageIcons),
  setup: function setup() {
    var _useAppBanner = useAppBanner(),
      isAppBannerVisible = _useAppBanner.isAppBannerVisible;
    var _useFirebaseMessaging = useFirebaseMessaging(),
      showFirebaseSnackbar = _useFirebaseMessaging.showFirebaseSnackbar,
      snackbarTitle = _useFirebaseMessaging.snackbarTitle,
      snackbarBody = _useFirebaseMessaging.snackbarBody,
      snackbarIcon = _useFirebaseMessaging.snackbarIcon,
      handleOnForegroundNotificationClick = _useFirebaseMessaging.handleOnForegroundNotificationClick;
    var _useBreakpoints = useBreakpoints(),
      isLarge = _useBreakpoints.isLarge;
    useTrustpilotWidget();
    var _useCommonVars = useCommonVars(),
      labels = _useCommonVars.wkLabels;
    return {
      isLarge: isLarge,
      isAppBannerVisible: isAppBannerVisible,
      //useFirebaseMessagging
      showFirebaseSnackbar: showFirebaseSnackbar,
      snackbarTitle: snackbarTitle,
      snackbarBody: snackbarBody,
      snackbarIcon: snackbarIcon,
      labels: labels,
      handleOnForegroundNotificationClick: handleOnForegroundNotificationClick
    };
  },
  data: function data() {
    return {
      wikistory: {
        title: [this.labels.wikistoryTitle1, this.labels.wikistoryTitle2, this.labels.wikistoryTitle3, this.labels.wikistoryTitle4, this.labels.wikistoryTitle5, this.labels.wikistoryTitle6],
        yearMobile: ["2016", "2018", "2019", "2022", "2022", "2024"],
        yearDesktop: ["2016", "2018", "2019", "2022", "2022", "2024"],
        description: [this.labels.wikistoryDescription1, this.labels.wikistoryDescription2, this.labels.wikistoryDescription3, this.labels.wikistoryDescription4, this.labels.wikistoryDescription5, this.labels.wikistoryDescription6]
      },
      wikistoryIndex: 0,
      intervalToStop: null
    };
  },
  computed: Object.assign(Object.assign(Object.assign({}, mapState(useLoggedUserStore, ["isUserLogged"])), mapState(usePublicUserMenuStore, ["favoritesCounter", "requestsCounter", "savedSearchesCounter", "mailConfirmed", "name"])), mapState(useModalStore, ["showModal"])),
  created: function created() {
    this.initPublicUserMenu();
  },
  mounted: function mounted() {
    var _this = this;
    this.setActiveWikihistory(this.wikistoryIndex);
    // DESKTOP SLIDER INTERVAL
    if (window.screen.width > BREAKPOINT.SMALL) {
      this.intervalToStop = setInterval(function () {
        if (_this.wikistoryIndex === _this.wikistory.title.length - 1) {
          _this.wikistoryIndex = 0;
          _this.setActiveWikihistory(_this.wikistoryIndex);
        } else _this.setActiveWikihistory(_this.wikistoryIndex + 1);
      }, 5000);
    }
  },
  methods: Object.assign(Object.assign({
    scrollToDifferences: function scrollToDifferences() {
      var whatDifferences = this.$refs.whatDifferences;
      whatDifferences.scrollIntoView({
        behavior: "smooth"
      });
    },
    setActiveWikihistory: function setActiveWikihistory(n) {
      var stopIntervalFromClick = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (stopIntervalFromClick) clearInterval(this.intervalToStop);
      var wikiBar = document.getElementById("wikistoryBarDesktop");
      var wikiBtn = document.getElementById("wikistoryBtn[".concat(n, "]"));
      var _iterator = _createForOfIteratorHelper(wikiBar.children),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var child = _step.value;
          child.classList.remove("active");
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.wikistoryIndex = n;
      wikiBtn === null || wikiBtn === void 0 ? void 0 : wikiBtn.classList.add("active");
    },
    activeRightCard: function activeRightCard(e) {
      var container = e === null || e === void 0 ? void 0 : e.target;
      var barPosition = container.scrollLeft;
      var firstDot = this.$refs.hFirstDot;
      var secondDot = this.$refs.hSecondDot;
      var thirdDot = this.$refs.hThirdDot;
      if (barPosition < 250 && !firstDot.classList.contains("active")) {
        firstDot.classList.add("active");
        secondDot.classList.remove("active");
        thirdDot.classList.remove("active");
      } else if (barPosition > 250 && barPosition < 650 && !secondDot.classList.contains("active")) {
        firstDot.classList.remove("active");
        secondDot.classList.add("active");
        thirdDot.classList.remove("active");
      } else if (barPosition > 650 && !thirdDot.classList.contains("active")) {
        firstDot.classList.remove("active");
        secondDot.classList.remove("active");
        thirdDot.classList.add("active");
      }
    },
    setActiveDot: function setActiveDot(dotRef, cardRef) {
      var _a;
      var firstDot = this.$refs.hFirstDot;
      var secondDot = this.$refs.hSecondDot;
      var thirdDot = this.$refs.hThirdDot;
      firstDot.classList.remove("active");
      secondDot.classList.remove("active");
      thirdDot.classList.remove("active");
      dotRef.classList.add("active");
      var e = cardRef;
      var hContainer = document.getElementById("highlights");
      var widthContainer = hContainer.offsetWidth;
      var secondCardScroll = (_a = document.getElementById("hSecondCard")) === null || _a === void 0 ? void 0 : _a.offsetWidth;
      switch (e.id) {
        case "hFirstCard":
          hContainer.scrollLeft = 0;
          break;
        case "hSecondCard":
          hContainer.scrollLeft = secondCardScroll;
          break;
        case "hThirdCard":
          hContainer.scrollLeft = secondCardScroll * 2;
          break;
      }
    },
    openTrendUrl: function openTrendUrl() {
      window.open("".concat(window._baseURL, "/quotazione-immobili/"), "_blank");
    }
  }, mapActions(useModalStore, ["setShowModal"])), mapActions(useBaseStore, ["initPublicUserMenu", "logout"])
  /*        ...mapMutations(["setShowModal"]),
  ...mapActions(["initPublicUserMenu", "logout"])*/)
});
aboutUsApp.use(createPinia());
aboutUsApp.mount("#about-us-main");